const i = {
  "social-media": "social-media",
  "social-media__overline": "social-media__overline",
  "social-media__links-list": "social-media__links-list",
  "social-media__icon": "social-media__icon",
  "social-media__link-wrapper": "social-media__link-wrapper",
  "social-media__link": "social-media__link",
  "social-media--align-left": "social-media--align-left",
  "social-media--align-center": "social-media--align-center",
  "social-media--align-right": "social-media--align-right"
};
export {
  i as default
};
